import { salesDataClientSourceTaskCancellation } from 'commons/service/bank/salesData'
import { SalesDataClientSourceCancelTaskPayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataClientSourceCancellation: WriteHook<SalesDataClientSourceCancelTaskPayload, void> = (opts) =>
  useMutationManager<SalesDataClientSourceCancelTaskPayload, void>(salesDataClientSourceTaskCancellation, opts)
